import { createStyles, makeStyles } from '@hawkins/styles';
function listItemWrapperStyles() {
    return createStyles({
        /** Class name of the `li` wrapper element. */
        root: {
            listStyleType: 'none',
        },
    });
}
export var useListItemWrapperStyles = makeStyles(listItemWrapperStyles(), { name: 'Hawkins-ListItemWrapper' });
